module.exports = __webpack_public_path__ + "img/VetoSansCond-LightItalic_1.e1703586.svg";